// extracted by mini-css-extract-plugin
var _1 = "assets-js-ViewInvitation-components-Guestlist-Post-Comment-module__comment__kmGNU";
var _2 = "assets-js-ViewInvitation-components-Guestlist-Post-Comment-module__commentActions__QD4T3";
var _3 = "assets-js-ViewInvitation-components-Guestlist-Post-Comment-module__commentContent__rirUW";
var _4 = "assets-js-ViewInvitation-components-Guestlist-Post-Comment-module__replyButton__tjp9y";
export { _1 as "comment", _2 as "commentActions", _3 as "commentContent", _4 as "replyButton" }
